import React, { PropsWithChildren, ReactElement } from 'react';

import Button from 'atomic/button/button';

import joinUsClientSvg from 'assets/images/join-us/join-us-client.inline.svg';

import './join-us-form-layout.scss';

interface JoinUsFormLayoutProps {
    footerButtonLabel: string;
    footerButtonOnClick: () => void;
}

const JoinUsFormLayout: React.FC<PropsWithChildren<JoinUsFormLayoutProps>> = ({ footerButtonLabel, footerButtonOnClick, children }): ReactElement => (
    <div className="join-us-form-layout">
        <p className="join-us-form-layout__header">
            <strong className="join-us-form-layout__header-strong">
                Jestem użytkownikiem
            </strong>
            {' '}
            i chcę zaproponować sklep lub firmę
        </p>
        <div className="join-us-form-layout__body">
            <div className="join-us-form-layout__block">
                {children}
            </div>
            <div className="join-us-form-layout__block">
                <img src={joinUsClientSvg} alt="Jestem użytkownikiem" title="Jestem użytkownikiem"/>
            </div>
        </div>
        <div className="join-us__footer">
            <Button className="join-us__footer-button" wrapper={true} onClick={footerButtonOnClick}>
                {footerButtonLabel}
            </Button>
        </div>
    </div>
);

export default JoinUsFormLayout;
